// extracted by mini-css-extract-plugin
export default {"iconContainer":"SocialIcon_iconContainer__sbYM1"};